import { render, staticRenderFns } from "./ProdesPampa.vue?vue&type=template&id=18d6d665&lang=pug"
import script from "./ProdesPampa.vue?vue&type=script&lang=js"
export * from "./ProdesPampa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports